const casinoOptions = {
  displayLabelsTitle: false,
  mainPicture: 'ProductPictures',
  secondaryPicture: null,
};

export default casinoOptions;
